module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAsCAMAAAAtr3oOAAAARVBMVEUAAABISEhISEhJSUlISEhISEhISEhISEhCQkJISEhHR0dISEhISEhISEhISEhKSkpISEhJSUlHR0dHR0dHR0dFRUVISEgVf5O9AAAAFnRSTlMA30DvjyC/bxBg75+Af18wz6+vcFAwHhiaawAAAMhJREFUeF7t0DmOw0AMBdHP3rV7rfsfdQChATkRxGAAJ34RgyIDatfqwzhlj1WfhsgF+1hIUGrWqW0okI46Vl0YjKlPxE2XcuS5D0aVQ2Bs+3GTS9nP3lnl8qJIMt5yyYySQE7wvfyX//JfbgS5bIySEotcZiZJAd/5HNm7BZ669IokqfdWQ9OpFuYCk7rBOJSsLhQOseoQUol01np9pLd09r1sTH0gNdcHZkm6cZdHgFWasSyXyvgeIMspYZFFbgWS/JpZ03/4A1fqFouHhoZYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/img/icons/inbox.png
// module id = 1017
// module chunks = 0